module.exports = __webpack_public_path__ + "img/37.97b8e5fb.png";